import React from "react";
import ReactDOM from "react-dom";
import Results from './results';

class App extends React.Component {
  render() {
    const searchQuery = location.search.substring(1);
    let quizResults = '';

    if (
      searchQuery !== '' &&
      searchQuery.includes('fe') &&
      searchQuery.includes('ae') &&
      searchQuery.includes('handles')
    ) {
      let searchObject = JSON.parse('{"' + searchQuery.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === "" ? value : decodeURIComponent(value) });

      delete Object.assign(searchObject, { ['firstName']: searchObject['fe'] })['fe'];
      delete Object.assign(searchObject, { ['age']: searchObject['ae'] })['ae'];
      delete Object.assign(searchObject, { ['gender']: searchObject['ge'] })['ge'];

      const numberedHandles = searchObject.handles.split(',');
      const numberedPriorities = searchObject.priority.split(',');
      const numberedDiets = searchObject.selectedDiets.split(',');
      const natalAnswers = searchObject.na.split(',');
      let urlHandles = [];
      let urlPriorities = [];
      let urlDiets = [];
      let urlNatalAnswers = [];

      numberedHandles.forEach(handle => {
        switch (handle) {
          case '1':
            urlHandles.push('5-htp');
            break;
          case '2':
            urlHandles.push('apple-cider-vinegar');
            break;
          case '3':
            urlHandles.push('ashwagandha-extract');
            break;
          case '4':
            urlHandles.push('beetroot-powder');
            break;
          case '5':
            urlHandles.push('beta-glucan');
            break;
          case '6':
            urlHandles.push('careflow-mango-powder');
            break;
          case '7':
            urlHandles.push('coq10');
            break;
          case '8':
            urlHandles.push('cordyceps');
            break;
          case '9':
            urlHandles.push('folic-acid');
            break;
          case '10':
            urlHandles.push('ginger-extract');
            break;
          case '11':
            urlHandles.push('ginseng');
            break;
          case '12':
            urlHandles.push('bpl1-ht');
            break;
          case '13':
            urlHandles.push('hydrocurc-pepperine');
            break;
          case '14':
            urlHandles.push('iron');
            break;
          case '15':
            urlHandles.push('k2-vital-delta');
            break;
          case '16':
            urlHandles.push('lactospore-probiotic');
            break;
          case '17':
            urlHandles.push('lycopene');
            break;
          case '18':
            urlHandles.push('maca-powder');
            break;
          case '19':
            urlHandles.push('milk-thistle-extract');
            break;
          case '20':
            urlHandles.push('nourished-greens');
            break;
          case '21':
            urlHandles.push('resveratrol');
            break;
          case '22':
            urlHandles.push('scutellup');
            break;
          case '23':
            urlHandles.push('selenium');
            break;
          case '24':
            urlHandles.push('silica');
            break;
          case '25':
            urlHandles.push('tart-cherry');
            break;
          case '26':
            urlHandles.push('vegan-vitamin-d3');
            break;
          case '27':
            urlHandles.push('vitamin-a');
            break;
          case '28':
            urlHandles.push('b12');
            break;
          case '29':
            urlHandles.push('vitamin-c');
            break;
          case '30':
            urlHandles.push('vitamin-e');
            break;
          case '31':
            urlHandles.push('white-kidney-extract');
            break;
          case '32':
            urlHandles.push('zinc');
            break;
          case '33':
            urlHandles.push('inositol');
            break;
          case '34':
            urlHandles.push('soy-isoflavones');
            break;
          case '35':
            urlHandles.push('lutemax');
            break;
          case '36':
            urlHandles.push('iodine');
            break;
          default:
            break;
        }
      });

      numberedPriorities.forEach(priority => {
        switch (priority) {
          case '1':
            urlPriorities.push('Lose weight or tone up');
            break;
          case '2':
            urlPriorities.push('More energy');
            break;
          case '3':
            urlPriorities.push('Better immunity');
            break;
          case '4':
            urlPriorities.push('Better focus & memory');
            break;
          case '5':
            urlPriorities.push('Improve skin');
            break;
          case '6':
            urlPriorities.push('Better stress management & mental wellbeing');
            break;
          case '7':
            urlPriorities.push('Delay signs of aging');
            break;
          case '8':
            urlPriorities.push('Cardiovascular health');
            break;
          case '9':
            urlPriorities.push('Improve performance, endurance & recovery');
            break;
          case '10':
            urlPriorities.push('Healthier hair & nails');
            break;
          case '11':
            urlPriorities.push('Tackle excess hair');
            break;
          case '12':
            urlPriorities.push('Menstrual cycle health');
            break;
          case '13':
            urlPriorities.push('Reduce hot flashes & sweating');
            break;
          case '14':
            urlPriorities.push('Gut health & digestion');
            break;
          case '15':
            urlPriorities.push('Increase libido / sexual health');
            break;
          case '16':
            urlPriorities.push('Improve sleep quality');
            break;
          case '17':
            urlPriorities.push('Bone & joint health');
            break;
          default:
            break;
        }
      });

      numberedDiets.forEach(diet => {
        switch (diet) {
          case '1':
            urlDiets.push('vegetarian');
            break;
          case '2':
            urlDiets.push('vegan');
            break;
          case '3':
            urlDiets.push('pescatarian');
            break;
          case '4':
            urlDiets.push('dairy free');
            break;
          case '5':
            urlDiets.push('gluten free');
            break;
          case '6':
            urlDiets.push('nut free');
            break;
          case '7':
            urlDiets.push('reducetarian');
            break;
          default:
            break;
        }
      });

      natalAnswers.forEach(answer => {
        switch (answer) {
          case '1':
            urlNatalAnswers.push('pregnant');
            break;
          case '2':
            urlNatalAnswers.push('breastfeeding');
            break;
          case '3':
            urlNatalAnswers.push('postnatal');
            break;
          case '4':
            urlNatalAnswers.push('trying to conceive');
          default:
            break;
        }
      });


      searchObject["handles"] = urlHandles;
      searchObject["priority"] = urlPriorities;
      searchObject["selectedDiets"] = urlDiets.join(', ');
      searchObject["natalAnswers"] = urlNatalAnswers.join(', ');

      quizResults = searchObject;
      window.localStorage.setItem('nourished-core-quiz-results', JSON.stringify(searchObject));
    } else {
      quizResults = JSON.parse(window.localStorage.getItem("nourished-core-quiz-results"));
    }

    return (
      <Results quizResults={quizResults} />
    )
  }
}

const rootElement = document.getElementById("quiz-results-root");
ReactDOM.render(<App />, rootElement);
